import React from "react";

function SubmissionApprovalSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          id="Group_9771"
          data-name="Group 9771"
          transform="translate(-1013 -262)"
        >
          <circle
            id="Ellipse_3595"
            data-name="Ellipse 3595"
            cx="20"
            cy="20"
            r="20"
            transform="translate(1013 262)"
            fill="#e8f0fe"
          />
          <g id="pending_actions_black_24dp" transform="translate(1021 270)">
            <rect
              id="Rectangle_14184"
              data-name="Rectangle 14184"
              width="24"
              height="24"
              fill="none"
            />
            <path
              id="Path_40086"
              data-name="Path 40086"
              d="M17,12a5,5,0,1,0,5,5A5,5,0,0,0,17,12Zm1.65,7.35L16.5,17.2V14h1v2.79l1.85,1.85ZM18,3H14.82A2.988,2.988,0,0,0,9.18,3H6A2.006,2.006,0,0,0,4,5V20a2.006,2.006,0,0,0,2,2h6.11a6.743,6.743,0,0,1-1.42-2H6V5H8V8h8V5h2v5.08a7.03,7.03,0,0,1,2,.6V5A2.006,2.006,0,0,0,18,3ZM12,5a1,1,0,1,1,1-1A1,1,0,0,1,12,5Z"
              fill="#276ef1"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default SubmissionApprovalSvgComponent;
